<template>
  <div class="layout-about">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'LayoutAbout',
  data() {
    return {};
  },
  created() {},
  mounted() {}
};
</script>

<style scoped lang="scss">
/* @import url(); 引入css类 */
</style>
